import { styled } from '@zenbusiness/zui/styles';

const AccountWrapperStyle = ({ theme, disabled }) => ({
  width: '100%',
  height: 'auto',
  padding: '24px 16px',
  display: 'flex',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: disabled ? 0.7 : 1,
  backgroundColor: disabled
    ? theme.palette.background.grey.dark
    : theme.palette.background.grey.light,
  cursor: disabled ? 'not-allowed' : 'pointer'
});

const AccountWrapperStyleV2 = ({ theme }) => ({
  width: '100%',
  height: 'auto',
  padding: '12px 16px',
  display: 'flex',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.background.grey.light,
  [theme.breakpoints.up('md')]: {
    padding: '24px'
  }
});

export const AccountWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled'
})(AccountWrapperStyle);

export const AccountWrapperV2 = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled'
})(AccountWrapperStyleV2);
